export var ContactFormEndpoints = {
    submitContactForm: function () { return "/public/contact-forms"; },
};
